/**
 * WikiPage — /wiki
 * Transformed into the 'Recallis // Neural Archive' clinical interface.
 */
import NeuralGraph from '../components/dashboard/NeuralGraph'

export default function WikiPage() {
  return (
    <div style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <NeuralGraph fullInterface={true} />
    </div>
  )
}
